import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { newsList } from "@/mocks/news";
import MovieCard from "@/components/feature/MovieCard";
import HeroCarousel from "./components/HeroCarousel";

export default function Home() {
  const featured = movies.filter((m) => m.featured).slice(0, 6);
  const latest = [...movies].sort((a, b) => b.year - a.year).slice(0, 10);
  const highlights = movies.filter((m) => m.featured).slice(0, 3);
  const latestNews = [...newsList].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 3);

  return (
    <div className="flex flex-col w-full">
      <HeroCarousel items={featured} />

      {/* 分类快捷入口 */}
      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {[
            {
              label: "电影",
              desc: "在大银幕之外，先读懂每一个故事",
              to: "/category?type=movie",
              img: "https://readdy.ai/api/search-image?query=cinematic%20movie%20theater%20seats%20in%20deep%20blue%20darkness%20with%20a%20glowing%20screen%20and%20warm%20orange%20light%2C%20artistic%20minimalist%20photography&width=900&height=520&seq=fly-cate-movie&orientation=landscape",
            },
            {
              label: "电视剧",
              desc: "一集一集，把日子过成别人的故事",
              to: "/category?type=tv",
              img: "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20a%20glowing%20television%20at%20night%2C%20deep%20blue%20ambient%20with%20warm%20orange%20lamp%20light%2C%20artistic%20minimalist%20photography&width=900&height=520&seq=fly-cate-tv&orientation=landscape",
            },
          ].map((c) => (
            <Link
              key={c.label}
              to={c.to}
              className="group relative h-[200px] md:h-[240px] rounded-lg overflow-hidden border border-background-200 cursor-pointer"
            >
              <img src={c.img} alt={`${c.label}分类`} title={`${c.label}分类 影视内容`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/85 to-primary-950/30"></div>
              <div className="absolute inset-0 p-5 md:p-7 flex flex-col justify-center">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-2 flex items-center gap-2">
                  {c.label}
                  <i className="ri-arrow-right-line text-accent-400 text-xl transition-transform group-hover:translate-x-1" aria-hidden="true"></i>
                </h2>
                <p className="text-sm text-background-200 max-w-xs">{c.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* 最新影视推荐 */}
      <section className="w-full px-4 md:px-8 pb-10 md:pb-14">
        <div className="flex items-end justify-between mb-5 md:mb-7">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 flex items-center gap-2">
              <span className="w-1 h-6 rounded bg-accent-500"></span>
              最新影视推荐
            </h2>
            <p className="text-sm text-foreground-600 mt-1.5">近期上线的电影与剧集，先看简介再决定要不要追</p>
          </div>
          <Link to="/category" className="text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap flex items-center gap-1">
            查看全部
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </Link>
        </div>

        {latest.length === 0 ? (
          <div className="py-16 text-center text-foreground-500 border border-dashed border-background-300 rounded-lg">
            <i className="ri-film-line text-3xl mb-3 inline-block" aria-hidden="true"></i>
            <p>暂无最新推荐，敬请期待</p>
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
            {latest.map((m) => (
              <MovieCard key={m.id} movie={m} />
            ))}
          </div>
        )}
      </section>

      {/* 精选剧情介绍 */}
      <section className="w-full bg-background-100 border-y border-background-200 py-10 md:py-14 px-4 md:px-8">
        <div className="mb-6 md:mb-8">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 flex items-center gap-2">
            <span className="w-1 h-6 rounded bg-accent-500"></span>
            精选剧情介绍
          </h2>
          <p className="text-sm text-foreground-600 mt-1.5">读懂一部作品的灵魂，从它的故事开始</p>
        </div>

        <div className="flex flex-col gap-6 md:gap-8">
          {highlights.map((m, i) => (
            <article
              key={m.id}
              className={`flex flex-col ${i % 2 === 1 ? "lg:flex-row-reverse" : "lg:flex-row"} gap-5 md:gap-8 items-stretch`}
            >
              <Link to={`/detail/${m.id}`} className="lg:w-[46%] shrink-0 relative h-[220px] md:h-[300px] rounded-lg overflow-hidden border border-background-200 cursor-pointer">
                <img src={m.backdrop} alt={`${m.title} 剧照`} title={`${m.title} 剧情介绍`} className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/70 to-transparent"></div>
                <span className="absolute bottom-3 left-3 px-2.5 py-1 rounded-md bg-accent-500 text-background-50 text-xs font-bold">
                  {m.type === "movie" ? "电影" : "电视剧"}
                </span>
              </Link>
              <div className="flex-1 flex flex-col justify-center">
                <h3 className="text-lg md:text-2xl font-heading font-bold text-foreground-950 mb-3">
                  <Link to={`/detail/${m.id}`} className="hover:text-primary-600 transition-colors">
                    {m.title}
                  </Link>
                </h3>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4 line-clamp-4">{m.synopsis}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {m.tags.map((t) => (
                    <span key={t} className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
                      #{t}
                    </span>
                  ))}
                </div>
                <div className="flex items-center gap-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-star-line text-primary-500" aria-hidden="true"></i>
                    导演 {m.director}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-fire-line text-accent-500" aria-hidden="true"></i>
                    热度 {m.rating.toFixed(1)}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* 影视资讯快报 */}
      <section className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex items-end justify-between mb-5 md:mb-7">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 flex items-center gap-2">
              <span className="w-1 h-6 rounded bg-accent-500"></span>
              影视资讯快报
            </h2>
            <p className="text-sm text-foreground-600 mt-1.5">行业动态与片单消息，第一时间了解</p>
          </div>
          <Link to="/news" className="text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap flex items-center gap-1">
            全部资讯
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </Link>
        </div>

        {latestNews.length === 0 ? (
          <div className="py-16 text-center text-foreground-500 border border-dashed border-background-300 rounded-lg">
            <p>暂无资讯，敬请期待</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
            {latestNews.map((n) => (
              <Link
                key={n.id}
                to="/news"
                className="group flex flex-col p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
              >
                <span className="self-start px-2 py-0.5 rounded bg-accent-100 text-accent-900 text-xs mb-3">{n.category}</span>
                <h3 className="text-base font-medium text-foreground-950 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {n.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-3 mb-4">{n.summary}</p>
                <span className="mt-auto text-xs text-foreground-500 flex items-center gap-1.5">
                  <i className="ri-calendar-line" aria-hidden="true"></i>
                  {n.date}
                </span>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}